import { render, staticRenderFns } from "./TabContract.vue?vue&type=template&id=39be28f5&scoped=true&"
import script from "./TabContract.vue?vue&type=script&lang=js&"
export * from "./TabContract.vue?vue&type=script&lang=js&"
import style0 from "./TabContract.vue?vue&type=style&index=0&id=39be28f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39be28f5",
  null
  
)

export default component.exports